import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icons';
import Button from './Button';
import { useAuth } from '../../context/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <>
      <header className={`fixed inset-x-0 top-0 z-sticky transition-all ${scrolled ? 'border-b border-border-subtle bg-surface-0/85 backdrop-blur-xl' : 'bg-transparent'}`}>
        <nav className="container-app flex h-[4.5rem] items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="grid h-9 w-9 place-items-center rounded-xl bg-accent text-surface-0">
              <Icon name="crane" size={19} />
            </span>
            <span className="font-semibold tracking-tight">ТехАрена</span>
          </Link>
          <div className="flex items-center gap-2">
            {user ? (
              <>
                <Link to="/profile"><Button variant="ghost" size="sm">Профиль</Button></Link>
                <Button variant="secondary" size="sm" onClick={logout}>Выйти</Button>
              </>
            ) : (
              <>
                <Link to="/login"><Button variant="ghost" size="sm">Войти</Button></Link>
                <Link to="/register"><Button variant="primary" size="sm">Регистрация</Button></Link>
              </>
            )}
          </div>
        </nav>
      </header>
      <div className="h-[4.5rem]" aria-hidden="true" />
    </>
  );
};

export default Navbar;
